import $ from "jquery";
window.$ = window.jQuery = $;

import lightGallery from 'lightgallery';
import lgZoom from 'lightgallery/plugins/zoom'

window.lightGallery = lightGallery;
window.lgZoom = lgZoom;

require('./components/sliders');
require('./components/forms');
require('./components/uploadFile');
require('./components/main_menu');
require('./components/goods');
require('./components/card');
require('./components/add_to_wishlist');
require('./components/autorization_modal');
require('./components/club_modal');
require('./components/filters');
require('./components/select');
require('./components/GTM.js');

$(document).ready(function () {
    require("jquery-lazy");
    $('.car_list_wrapper .js__tab_header').first().trigger('click');

    lazyLoad();

    collectionNavigate()
    categoriesNavigate()
    collectionNameHeight()
    footerMenuOpen()
    activeFilters()

    $(window).on('resize', function() {
        collectionNavigate()
        categoriesNavigate()
        if ($('.js_collection__slider').length) {
            collectionNameHeight()
        } else if ($('.js_goods-list__list').length) {
            window.goodListNameHeight()
        }
    });
})

function lazyLoad() {
    $("img.lazy").Lazy();
}

window.lazyLoad = lazyLoad;

function collectionNavigate() {
    let width = $('.js_card__main-image').innerWidth()
    let buttonHeight = $('.js_collection__tile-prev').innerHeight()
    let buttonPosition = width / 2 - buttonHeight / 2
    $('.js_collection__tile-prev').css('top', buttonPosition)
    $('.js_collection__tile-next').css('top', buttonPosition)

    function buttonsDisabled(lengthSlider, id) {

        if (($(window).outerWidth() > 1535 && lengthSlider <= 4)
        || (($(window).outerWidth() > 1023 && $(window).outerWidth() < 1536) && lengthSlider <= 3)
        || (($(window).outerWidth() > 567 && $(window).outerWidth() < 1024) && lengthSlider <= 2)
        || ($(window).outerWidth() < 568 && lengthSlider <= 1)) {
            $(id).find('.js_collection__tile-prev').addClass('disabled')
            $(id).find('.js_collection__tile-next').addClass('disabled')
        } else {
            $(id).find('.js_collection__tile-prev').removeClass('disabled')
            $(id).find('.js_collection__tile-next').removeClass('disabled')
        }
    }

    $('.js_collection__tile-holder').each((i, el) => {
        let length = $(el).find('.js_card').length
        buttonsDisabled(length, el)
    })
}

function categoriesNavigate() {
    let width = $('.js_categories__image').outerWidth()
    let buttonHeight = $('.js_categories__prev').innerHeight()
    let buttonPosition = width / 2 - buttonHeight / 2
    let length = $('#categories_slider').find('.js_categories__item').length
    $('.js_categories__prev').css('top', buttonPosition)
    $('.js_categories__next').css('top', buttonPosition)
    if (($(window).outerWidth() > 1535 && length <= 7)
    || (($(window).outerWidth() > 1023 && $(window).outerWidth() < 1536) && length <= 5)
    || (($(window).outerWidth() > 767 && $(window).outerWidth() < 1024) && length <= 3)
    || (($(window).outerWidth() > 567 && $(window).outerWidth() < 768) && length <= 2)
    || ($(window).outerWidth() < 568 && length <= 1)) {
        $('.js_categories__prev').addClass('disabled')
        $('.js_categories__next').addClass('disabled')
    } else {
        $('.js_categories__prev').removeClass('disabled')
        $('.js_categories__next').removeClass('disabled')
    }
}

window.collectionNameHeight = collectionNameHeight

function collectionNameHeight() {
    function slidersNameHeight(id) {
        let slider = $(`${id} .js_collection__slider`).find('.js_card__main-item.active .js_card__main-name')
        let maxHeightSlider = 0
        $(`${id} .js_collection__slider`).find('.js_card__main-name').removeAttr('style')
        slider.each((i, el) => {
            $(el).innerHeight() > maxHeightSlider ? maxHeightSlider = $(el).innerHeight() : ''
        })
        slider.each((i, el) => {
            $(el).innerHeight(maxHeightSlider)
        })
    }

    slidersNameHeight('#ralph_lauren_collection')
    slidersNameHeight('#hudson_valley_collection')
}

//Открытие подменю в футере
function footerMenuOpen() {
    $('.js_footer__title-button').on('click', function() {
        let list = $(this).closest('.js_footer__title_hide').next('.js_footer__content_hide')
        if ($('.js_footer__title-button').not(this).hasClass('active')) {
            $('.js_footer__title-button').removeClass('active')
            $('.js_footer__content_hide').slideUp(300)
        }
        $(this).toggleClass('active')
        list.slideToggle(300)
    })

    $(window).on('resize', function() {
        if ($(document).outerWidth() > 567) {
            $('.js_footer__title-button').removeClass('active')
            $('.js_footer__content_hide').removeAttr('style')
        }
    })
}

//Фильтры
function activeFilters() {
    $(document).on('click', '.js_filters__title', function() {
        if (!$(this).hasClass('active')) {
            $('.js_filters__title').removeClass('active')
            $('.js_filters__content').slideUp()
            $(this).addClass('active')
            $(this).next('.js_filters__content').slideDown()
        } else {
            $(this).removeClass('active')
            $(this).next('.js_filters__content').slideUp()
        }
    })

    $(document).on('click', function(e) {
        if ($('.js_filters__title').hasClass('active')) {
            if (!$(e.target).closest('.js_filters__item').length) {
                $('.js_filters__title.active').removeClass('active')
                $('.js_filters__title').next('.js_filters__content').slideUp()
            }
        }        
    })

    $(document).on('click', '.js_filters__open', function() {
        $('.js_filters__modal').addClass('active')
        $('body').css('overflow', 'hidden')
        if (!$('.header').hasClass('main-header_white')) {
            $('.header').addClass('main-header_white')
        }
    })

    $(document).on('click', '.js_filters__close', function() {
        closeFilters()
        if ( $(window).scrollTop() == 0 && !$('.header').hasClass('header_white') ) {
            $('.header').removeClass('main-header_white')
        }
    })

    $(document).on('click', function(e) {
        if ($('.js_filters__modal').hasClass('active')) {
            if ($(e.target).closest('.js_filters__modal').length == 0 && !$(e.target).is('.js_filters__open')) {
                closeFilters()
            }
        }
    })
    
}

function closeFilters() {
    $('.js_filters__modal').removeClass('active')
    $('body').removeAttr('style')
}